import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Table, message, notification, Icon, Tooltip, Spin } from "antd";

//Component import
import LocationPageBuilder from "../PageBuilder";
import Empty from "../../../components/Custom/Empty";

//Utility
import { sortFunction } from "../../../../utility/sorter";
import { COOKIE, getCookie } from "../../../../services/cookie";
import { fetchApi } from "../../../../services/api";
import { cloneDeep, filter } from "lodash";
import { formatDate } from "../../../../utility/date";
import moment from "moment";

class DwarfTree extends Component {
  componentRef = React.createRef();
  state = {
    addModal: false,
    data: [],
    dynamicTableData: [],
    blockNumber: null,
    blockNoList: [],
    block_uuid: null,
    treeNo: null,
    researchCode: null,
    researchCodeList: [],
    researchCode_uuid: null,
    dwarfTree: [],
    dwarfTreeSelectedData: [],
    spatheNoList: [],
    spatheNo: null,
    researchDate: null,
    btnLoad: false,
    editData: null,
    isEdit: false,
    isDelete: false,
    addPopulateData: null,
    tableLoader: false,
    dwarfResearchData: [],
    dwarfResearchUuid: null,
    pagination: true,
    isAdded: false
  };

  componentDidMount() {
    this.setState({ tableLoader: true });
    this.fetchDwarfTreeResearch();
    this.fetchBlockNo();
    const tableCon = ReactDOM.findDOMNode(this.refs["table"]),
      table = tableCon.querySelector("table"),
      header = table.createTHead(),
      row = header.insertRow(0);
    //cell = row.insertCell(0);
    row.innerHTML = `<h1>Research Dwarf Tree - List &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Farm
    : ${getCookie(COOKIE.FARM)}${" "} </h1>`;
    table.setAttribute("id", "table-to-xls");
    table.setAttribute("class", "Tree-Research");
  }

  fetchBlockNo = () => {
    let { blockNumber } = this.state,
      url = "/blocksuuid";
    if (blockNumber) url += `?blockNo=${blockNumber}`;
    fetchApi(url, "get").then(data =>
      this.setState({ blockNoList: sortFunction(data, "blockNoFull") })
    );
  };

  fetchDwarfTreeResearch = (reload = true) => {
    if (reload) {
      this.setState({
        tableLoader: true,
        dynamicTableData: [],
        pagination: false
      });
      let { block_uuid, researchCode, researchDate } = this.state,
        url = "/dwarf_researches";
      if (block_uuid) url += `?block.uuid=${block_uuid}`;
      if (researchCode) url += `&research.code=${researchCode}`;
      if (researchDate) {
        if (block_uuid && researchDate) {
          url += `&researchDate%5Bbefore%5D=${moment(researchDate).format(
            "YYYY-MM-DD"
          )}`;
          url += `&researchDate%5Bafter%5D=${moment(researchDate).format(
            "YYYY-MM-DD"
          )}`;
        } else {
          url += `?researchDate%5Bbefore%5D=${moment(researchDate).format(
            "YYYY-MM-DD"
          )}`;
          url += `&researchDate%5Bafter%5D=${moment(researchDate).format(
            "YYYY-MM-DD"
          )}`;
        }
      }
      fetchApi(url, "get")
        .then(data =>
          this.setState(
            {
              tableLoader: false,
              data: data.map(({ dateOfResearch, ...it }) => {
                return {
                  dateOfResearch: formatDate(dateOfResearch),
                  date: dateOfResearch,
                  ...it
                };
              })
            },
            () => {
              this.setState(
                {
                  dynamicTableData: sortFunction(this.state.data, "treeNo"),
                  pagination: true
                },
                () =>
                  this.setState(
                    {
                      dynamicTableData: sortFunction(
                        this.state.dynamicTableData,
                        "rowNo"
                      ),
                      pagination: true
                    },
                    () =>
                      this.setState(
                        {
                          dynamicTableData: sortFunction(
                            this.state.dynamicTableData,
                            "areaNo"
                          ),
                          pagination: true
                        },
                        () =>
                          this.setState({
                            dynamicTableData: sortFunction(
                              this.state.dynamicTableData,
                              "blockNo"
                            ),
                            pagination: true
                          })
                      )
                  )
              );
            }
          )
        )
        .catch(err => {
          this.setState({ tableLoader: false });
          message.error("Internal Server Error");
        });
    }
  };

  fetchDwarfTree = () => {
    let { block_uuid } = this.state;
    //fetchApi(`/dwarves?stageCode=3&block.uuid=${block_uuid}`, "get").then(
    fetchApi(
      `/dwarves?stageCode[]=2&stageCode[]=3&block.uuid=${block_uuid}`,
      "get"
    ).then(data => {
      this.setState({ dwarfTree: sortFunction(data, "treeNoFull") });
    });
  };

  addModalToggle = () => {
    let {
      blockNumber,
      block_uuid,
      researchCode,
      researchDate,
      addModal,
      addPopulateData,
      isEdit,
      isDelete,
      researchCode_uuid,
      isAdded
    } = this.state;

    if (addModal) {
      this.setState(
        {
          addModal: false,
          addPopulateData: null,
          editData: null,
          blockNumber: isEdit || isDelete || isAdded ? blockNumber : null,
          block_uuid: isEdit || isDelete || isAdded ? block_uuid : null,
          researchCode: isEdit || isDelete ? researchCode : null,
          researchCode_uuid: isEdit || isDelete ? researchCode_uuid : null,
          researchDate: isEdit || isDelete ? researchDate : null,
          addPopulateData: isAdded
            ? {
              //blockNo: blockNumber,
              //research: researchCode,
              //researchDate: researchDate
            }
            : null,
          isEdit: false,
          isDelete: false,
          isAdded: false
        }
        //() => this.fetchDwarfTreeResearch()
      );
    } else {
      if (!blockNumber) {
        message.info("Select Block No.");
        // } else if (!researchCode) {
        //   message.info("Please Select a Research Code");
        // } else if (!researchDate) {
        //   message.info("Please Select a Research Date");
      } else {
        this.fetchDwarfTree();
        this.setState(
          {
            // addModal: blockNumber
            //   ? researchCode
            //     ? researchDate
            //       ? !this.state.addModal
            //       : false
            //     : false
            //   : false
            addModal: blockNumber ? !this.state.addModal : false
          },
          () => {
            // if (researchCode || researchDate) {
            this.setState({
              addPopulateData: Object.assign(
                {},
                blockNumber ? { blockNo: blockNumber } : {},
                researchCode ? { research: researchCode } : {},
                researchDate ? { researchDate: researchDate } : {},
                cloneDeep(this.state.addPopulateData)
              )
            });
            // }
          }
        );
      }
    }
  };

  clearFields = () => {
    let { blockNumber } = this.state;
    this.setState({
      //spatheNo: null,
      //spatheNoList: null,
      researchDate: null,
      researchCode: null,
      addPopulateData: {
        //blockNumber: blockNumber ? blockNumber : null,
        spatheNo: null,
        //research: null,
        //researchDate: null,
        stage: null,
        treeType: null,
        area: null,
        row: null,
        details: null,
        tree: null,
        researchDate: null,
        research: null
      }
    });
  };

  addFormHandler = ({
    spatheNo,
    researchDate,
    research,
    block,
    area,
    row,
    treeType,
    tree,
    details,
    ...val
  }) => {
    //to remove the previous instances of
    notification.destroy();

    let {
      dwarfTreeSelectedData,
      researchCode_uuid,
      isEdit,
      dwarfResearchUuid,
      isDelete
    } = this.state;
    this.setState({ btnLoad: true });
    if (isEdit) {
      fetchApi(`/dwarf_researches/${dwarfResearchUuid}`, "put", {
        researchDate: researchDate.format("YYYY-MM-DD"),
        research: "/researches/" + researchCode_uuid,
        block: "/blocks/" + dwarfTreeSelectedData.blockUuid,
        area: "/areas/" + dwarfTreeSelectedData.areaUuid,
        row: "/rows/" + dwarfTreeSelectedData.rowUuid,
        treeType: "/tree_types/" + dwarfTreeSelectedData.treeTypeUuid,
        tree: "/dwarves/" + dwarfTreeSelectedData.uuid,
        details: details ? details : null,
        ...val
      }).then(res => {
        if (res) {
          notification.success({
            message: "Success",
            description: "Successfully updated Dwarf Tree Research"
          });
          this.fetchDwarfTreeResearch();
          this.addModalToggle()
        } else {
          notification.error({
            message: "Failed",
            description: "Failed to updated Dwarf Tree Research"
          });
        }
        this.setState({ btnLoad: false }
          //, () => this.addModalToggle()
        );
      });
    } else if (isDelete) {
      let today = new Date().toISOString().split("T")[0];
      fetchApi(`/dwarf_researches/${dwarfResearchUuid}`, "put", {
        dtDeleted: today
      }).then(res => {
        if (res) {
          notification.success({
            message: "Success",
            description: "Successfully deleted Dwarf Tree Research"
          });
          this.fetchDwarfTreeResearch();
          this.addModalToggle()
        } else {
          notification.error({
            message: "Failed",
            description: "Failed to deleted Dwarf Tree Research"
          });
        }
        this.setState({ btnLoad: false }
          //, () => this.addModalToggle()
        );
      });
    } else {
      fetchApi("/dwarf_researches", "post", {
        spatheNo: parseInt(spatheNo),
        researchDate: researchDate.format("YYYY-MM-DD"),
        research: "/researches/" + researchCode_uuid,
        block: "/blocks/" + dwarfTreeSelectedData.blockUuid,
        area: "/areas/" + dwarfTreeSelectedData.areaUuid,
        row: "/rows/" + dwarfTreeSelectedData.rowUuid,
        treeType: "/tree_types/" + dwarfTreeSelectedData.treeTypeUuid,
        tree: "/dwarves/" + dwarfTreeSelectedData.uuid,
        details: details ? details : null,
        ...val
      }).then(res => {
        if (res) {
          if (res.violations) {
            notification.error({
              message: "Failed",
              description: res.violations[0].message
            });
          } else {
            notification.success({
              message: "Success",
              description: "Successfully added Dwarf Tree Research"
            });
            this.setState(
              {
                isAdded: true
              },
              () => this.clearFields()
            );
            this.fetchDwarfTreeResearch();
          }
        } else {
          notification.error({
            message: "Failed",
            description: "Failed to add Dwarf Tree Research"
          });
        }
        this.setState({ btnLoad: false, addPopulateData: null });
      });
    }
  };

  onBlockChangeHandler = it => {
    let { blockNoList } = this.state;

    if (it) {
      fetchApi(
        "/researches?type=1&properties[]=uuid&properties[]=code",
        "get"
      ).then(res => {
        this.setState({ researchCodeList: res })
      });
    }

    this.setState(
      {
        blockNumber: it ? it : null,
        researchCode: null,
        researchCode_uuid: null,
        block_uuid: it
          ? cloneDeep(blockNoList).filter(item => item.blockNoFull == it)[0]
            .uuid
          : null,
        // researchCode: null,
        //researchCodeList: [],
        //researchDate: null,
        addPopulateData: {
          blockNo: it ? it : null
        }
      },
      () => this.fetchDwarfTreeResearch()
    );
  };

  onResearchCodeChangeHandler = (it, reload = true) => {
    let { researchCodeList } = this.state;

    this.setState(
      {
        researchCode: it ? it : null,
        researchCode_uuid: it
          ? cloneDeep(researchCodeList)?.filter(item => item.code == it)[0]?.uuid
          : null,
        addPopulateData: {
          research: it ? it : null
        }
        // researchDate: null
      },
      () => this.fetchDwarfTreeResearch(reload)
    );
  };

  onTreeNoChangeHandler = (treeUuid) => {
    if (treeUuid) {
      fetchApi(
        `/dwarves/${treeUuid}?groups[]=getNextSpatheNo`,
        "get"
      ).then((res) =>
        this.setState({
          spatheNo: res?.nextSpatheNo,
        }, () => {
          this.setState({
            btnLoad: false,
            loading: false,
            addPopulateData: {
              spatheNo: cloneDeep(this.state.spatheNo),
            }
          });
        })
      ).catch(() => {
        this.setState({
          btnLoad: false,
          loading: false,
        });
      });
    } else {
      this.setState({
        spatheNo: null,
      }, () => {
          this.setState({
            btnLoad: false,
            loading: false,
            addPopulateData: {
              spatheNo: null,
            }
          });
        }
      );
    }
  };

  onTreeNoChangeFetchSpatheNoListHandler = it => {
    let {
      block_uuid,
      dwarfTree,
      addPopulateData,
      isEdit,
      editData
    } = this.state;
    this.setState({
      treeNo: null,
      spatheNoList: [],
      spatheNo: null,
      addPopulateData: {
        spatheNo: null
      }
    });
    if (it) {
      if (!isEdit) {
        let treeUuid = cloneDeep(dwarfTree)?.filter(item => item.treeNoFull == it)?.[0]?.uuid
        this.setState({ loading: true, btnLoad: true });
        fetchApi(
          `/emasculation?block.uuid=${block_uuid}&tree.uuid=${treeUuid}&properties[]=spatheNo`, "get")
          .then(res =>
          this.setState({
            spatheNoList: sortFunction(res, "spatheNo"),
            addPopulateData: {
              spatheNo: null
            }
          }, () => this.onTreeNoChangeHandler(treeUuid))
        );
      }

      this.setState({
        dwarfTreeSelectedData: cloneDeep(dwarfTree).filter(
          item => item.treeNoFull == it
        )[0],
        treeNo: it
      });

      this.setState(() => {
        let temp = cloneDeep(dwarfTree).filter(
          item => item.treeNoFull == it
        )[0];
        return {
          addPopulateData: isEdit
            ? {
              stage:
                temp.stageCode == 1
                  ? "Seedling"
                  : temp.stageCode == 2
                    ? "Plant"
                    : "Tree",
              treeType: temp.treeType,
              area: temp.areaNo,
              row: temp.rowNo
            }
            : {
              stage:
                temp.stageCode == 1
                  ? "Seedling"
                  : temp.stageCode == 2
                    ? "Plant"
                    : "Tree",
              treeType: temp.treeType,
              area: temp.areaNo,
              row: temp.rowNo,
              ...addPopulateData
            }
        };
      });
    }
  };

  onSpatheNoChangeHandler = it => {
    this.setState({
      spatheNo: it ? it : null,
      addPopulateData: {
        spatheNo: it ? it : null
      }
    });
  };

  tableFilterHandler = () => {
    let { blockNumber, researchCode, data } = this.state,
      filterJson = {};
    if (blockNumber) filterJson.blockNo = blockNumber;
    if (researchCode) filterJson.researchCode = researchCode.toString();

    this.setState({
      dynamicTableData: filter(data, filterJson)
    });
  };

  dateOfResearchHandler = (date, string) => {
    let { data, researchDate, researchCode } = this.state;

    if (date) {
      this.setState(
        {
          researchDate: date,
          addPopulateData: {
            researchDate: date
            //research: researchCode
          }
        },
        () => this.fetchDwarfTreeResearch()
        // ,
        // () =>
        // this.setState({
        //   dynamicTableData: cloneDeep(data).filter(
        //     it => it.dateOfResearch == string
        //   ),
        //   addPopulateData: {
        //     researchDate: date
        //   }
        // })
      );
    } else {
      this.setState(
        {
          //dynamicTableData: data,
          researchDate: null,
          addPopulateData: {
            researchDate: null
            //research: researchCode
          }
        },
        () => this.fetchDwarfTreeResearch()
      );
    }
  };

  formdateOfResearchHandler = (date, string) => {
    let { data, researchDate, researchCode } = this.state;

    if (date) {
      this.setState({
        addPopulateData: {
          researchDate: date
          //research: researchCode
        }
      });
    } else {
      this.setState({
        addPopulateData: {
          researchDate: null
          //research: researchCode
        }
      });
    }
  };

  onActionClickHandler = (it, action) => {
    let { blockNoList, researchCodeList } = this.state;
    let blockuuid = cloneDeep(blockNoList)?.filter(
      item => item.blockNoFull === it.blockNo
    )[0]?.uuid;
    this.setState({ tableLoader: true });
    Promise.all([
      fetchApi(
        //`/dwarves?stageCode=3&block.uuid=${blockuuid}&treeNo=${it.treeNo}`,
        `/dwarves?stageCode[]=2&stageCode[]=3&block.uuid=${blockuuid}&treeNo=${it.treeNo}`,
        "get"
      ),
      // fetchApi(
      //   `/researches?type=1&properties[]=uuid&properties[]=code&code=${it.researchCode}`,
      //   "get"
      // ),
      fetchApi(
        `/dwarf_researches?tree.treeNo=${it.treeNo}&block.uuid=${blockuuid}&research.code=${it.researchCode}`,
        "get"
      )
    ]).then(data => {
      if(data?.[0]?.length === 0 || data?.[1]?.length === 0) {
        notification.error({
          message: "Failed",
          description: "Failed to fetch Dwarf Tree information."
        });
        this.setState({ tableLoader: false })
        return
      }
      this.setState(
        {
          isEdit: action === "edit" ? true : false,
          isDelete: action === "delete" ? true : false,
          dwarfTree: data[0],
          //researchCodeList: data[1],
          dwarfResearchData: data[1],
          tableLoader: false
        },
        () => {
          this.setState({
            dwarfTreeSelectedData: this.state.dwarfTree[0],
            //researchCode_uuid: this.state.researchCodeList[0].uuid,
            researchCode_uuid: cloneDeep(researchCodeList)?.filter(item => item.code == it.researchCode)[0]?.uuid,
            dwarfResearchUuid: this.state.dwarfResearchData[0]?.uuid,
            addModal: true,
            editData: {
              stage:
                this.state.dwarfTree[0]?.stageCode == 1
                  ? "Seedling"
                  : this.state.dwarfTree[0]?.stageCode == 2
                    ? "Plant"
                    : "Tree",
              tree: it.treeNo,
              treeType: it.treeType,
              researchDate: moment(it.date, "YYYY-MM-DD"),
              research: it.researchCode,
              blockNo: it.blockNo,
              area: it.areaNo,
              row: it.rowNo,
              details: this.state.dwarfResearchData[0]?.details
            }
          });
        }
      );
    }).catch(() => {
      this.setState({ tableLoader: false })
    });
  };

  render() {
    let {
      addModal,
      dynamicTableData,
      blockNoList,
      blockNumber,
      researchCodeList,
      researchCode,
      dwarfTree,
      spatheNoList,
      spatheNo,
      editData,
      isEdit,
      isDelete,
      addPopulateData,
      tableLoader,
      btnLoad,
      researchDate,
      pagination,
      data,
      treeNo
    } = this.state;
    const columns = [
      {
        title: "Tree No.",
        dataIndex: "treeNo"
      },
      {
        title: "Tree Type",
        dataIndex: "treeType"
      },
      {
        title: "Block No.",
        dataIndex: "blockNo"
      },
      {
        title: "Area No.",
        dataIndex: "areaNo"
      },
      {
        title: "Row No.",
        dataIndex: "rowNo"
      },
      {
        title: "Research Code",
        dataIndex: "researchCode"
      },
      {
        title: "Date of Research",
        dataIndex: "dateOfResearch"
      },
      {
        title: "Action",
        className: "action",
        render: it => (
          <Fragment>
            <Tooltip placement="topRight" title={"Edit"}>
              <Icon
                type="edit"
                className="table-action-btn"
                onClick={() => this.onActionClickHandler(it, "edit")}
              />
            </Tooltip>
            <Tooltip placement="topRight" title={"Delete"}>
              <Icon
                type="delete"
                className="table-action-btn"
                onClick={() => this.onActionClickHandler(it, "delete")}
              />
            </Tooltip>
          </Fragment>
        )
      }
    ],
      formItems =
        !isEdit && !isDelete
          ? [
            {
              name: "stage",
              placeholder: "Stage",
              disabled: true
            },
            {
              name: "treeType",
              placeholder: "Tree Type",
              disabled: true
            },
            {
              name: "blockNo",
              placeholder: "Block No.",
              disabled: true
            },
            {
              name: "area",
              placeholder: "Area No.",
              type: "number",
              disabled: true
            },
            {
              name: "row",
              placeholder: "Row No.",
              disabled: true
            },
            {
              name: "research",
              placeholder: "Research Code",
              listData: cloneDeep(researchCodeList).map(it => it.code),
              disabled: isDelete || isEdit ? true : false,
              changeHandler: it => this.onResearchCodeChangeHandler(it, false)
            },
            {
              name: "researchDate",
              placeholder: "Date of Research",
              type: "date",
              disabled: isDelete ? true : false,
              changeHandler: this.formdateOfResearchHandler
            },
            {
              name: "details",
              placeholder: "Details",
              type: "alphanumeric",
              required: false,
              disabled: isDelete ? true : false
            }
          ]
          : [
            {
              name: "stage",
              placeholder: "Stage",
              disabled: true
            },
            {
              name: "treeType",
              placeholder: "Tree Type",
              disabled: true
            },
            {
              name: "blockNo",
              placeholder: "Block No.",
              disabled: true
            },
            {
              name: "area",
              placeholder: "Area No.",
              type: "number",
              disabled: true
            },
            {
              name: "row",
              placeholder: "Row No.",
              disabled: true
            },
            {
              name: "research",
              placeholder: "Research Code",
              disabled: isDelete || isEdit ? true : false,
              changeHandler: it => this.onResearchCodeChangeHandler(it, false)
            },
            {
              name: "researchDate",
              placeholder: "Date of Research",
              type: "date",
              disabled: isDelete ? true : false,
              changeHandler: this.formdateOfResearchHandler
            },
            {
              name: "details",
              placeholder: "Details",
              type: "alphanumeric",
              required: false,
              disabled: isDelete ? true : false
            }
          ];
    const _formItems = isEdit
      ? [
        {
          name: "tree",
          placeholder: "Tree No.",
          // listData: dwarfTree
          //   ? cloneDeep(dwarfTree).map(it => it.treeNoFull)
          //   : "",
          disabled: true
          //changeHandler: it => this.onTreeNoChangeHandler(it)
        }
      ].concat(formItems)
      : isDelete
        ? [
          {
            name: "tree",
            placeholder: "Tree No.",
            // listData: dwarfTree
            //   ? cloneDeep(dwarfTree).map(it => it.treeNoFull)
            //   : "",
            disabled: true
          }
        ].concat(formItems)
        : [
          {
            name: "tree",
            placeholder: "Tree No.",
            listData: dwarfTree
              ? cloneDeep(dwarfTree).map(it => it.treeNoFull)
              : "",
            readonly: dwarfTree?.length > 0 ? false : true,
            changeHandler: it => this.onTreeNoChangeFetchSpatheNoListHandler(it)
          },
          {
            name: "spatheNo",
            placeholder: "Spathe No.",
            disabled:
              this.state.spatheNoList.length > 0 && treeNo ? false : true,
            listData: cloneDeep(spatheNoList).map(it => it.spatheNo),
            changeHandler: it => this.onSpatheNoChangeHandler(it)
          }
        ].concat(formItems);

    const buttonList =
      data.length > 0
        ? [
          {
            label: "Add",
            icon: "folder-add",
            onClickHandler: this.addModalToggle
          },
          /*{
          label: "Excel",
          icon: "file-text"
        },*/
          {
            label: "Print",
            icon: "diff",
            reference: this.componentRef
          },
          {
            label: this.state.pagination ? "View All" : "View Less",
            icon: "container",
            onClickHandler: () => this.setState({ pagination: !pagination })
          }
        ]
        : [
          {
            label: "Add",
            icon: "folder-add",
            onClickHandler: this.addModalToggle
          }
        ];

    return (
      <LocationPageBuilder
        title="Research Dwarf Tree"
        buttonList={buttonList}
        dropDownList={[
          {
            label: "Block",
            listItems: cloneDeep(blockNoList).map(it => it.blockNoFull),
            value: blockNumber ? blockNumber : undefined,
            changeHandler: it => this.onBlockChangeHandler(it)
          },
          {
            label: "Research Code",
            listItems: cloneDeep(researchCodeList).map(it => it.code),
            disabled: blockNumber ? false : true,
            value: researchCode ? researchCode : undefined,
            changeHandler: it => this.onResearchCodeChangeHandler(it)
          },
          {
            label: "Date of Research",
            type: "date",
            value: researchDate ? researchDate : undefined,
            changeHandler: this.dateOfResearchHandler
          }
        ]}
        addModal={addModal}
        addModalToggle={this.addModalToggle}
        addFormHandler={this.addFormHandler}
        btnLoad={btnLoad}
        editData={editData}
        addPopulateData={addPopulateData}
        formItems={_formItems}
        isEdit={isEdit}
        isDelete={isDelete}
      >
        <div ref={this.componentRef}>
          {/* <h1>
            Research Dwarf Tree - List &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Farm
            : {getCookie(COOKIE.FARM)}{" "}
          </h1> */}
          <Spin spinning={tableLoader} size="large">
            <Table
              ref="table"
              columns={columns}
              dataSource={dynamicTableData}
              pagination={!pagination ? pagination : { pageSize: 15 }}
            //loading={tableLoader}
            locale={{
              emptyText: <Empty />
            }}
            />
          </Spin>
        </div>
      </LocationPageBuilder>
    );
  }
}

export default DwarfTree;
